/*@ngInject*/
const OrganizationActionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.deactivateOrganization = function (organizationId, propagateStatusToChildren) {
        var url = '/rest/Organization/' + organizationId + '/deactivate',
            config = {
                params: {
                    propagateStatusToChildren: propagateStatusToChildren
                }
            };
        return this.post(url, {}, config);
    };

    this.activateOrganization = function (organizationId, propagateStatusToChildren) {
        var url = '/rest/Organization/' + organizationId + '/activate',
            config = {
                params: {
                    propagateStatusToChildren: propagateStatusToChildren
                }
            };
        return this.post(url, {}, config);
    };

    this.deleteOrganization = function (organizationId) {
        var url = '/rest/Organization/' + organizationId;
        return this.delete(url);
    };

    this.getFormSetId = function (organizationId) {
        var url = '/rest/Organization/' + organizationId + '/formset';
        return this.get(url);
    };

    this.updateEmailSignatureById = function (organizationId, emailSignature) {
        var url = '/rest/Organization/' + organizationId + '/emailSignature';
        return this.post(url, emailSignature);
    };
};

angular.module('ums.configuration')
    .service('organizationActionRepository', OrganizationActionRepository);
